// Data-access layer. v2.3: the browser no longer talks to Supabase — every call
// goes through the Node single door (src/api.js). Public interface is unchanged,
// so App.jsx needs no edits. On any failure the loaders return null and the app
// falls back to its in-memory SEED (graceful degradation).
import { apiGet, apiPost, apiDel, onTable } from "./api";

// Always "on": we always have an API to talk to. The server itself degrades.
export const dbEnabled = true;

async function safeLoad(path) {
  try {
    const rows = await apiGet(path);
    return Array.isArray(rows) ? rows : null;
  } catch (e) {
    console.error("[db] load failed:", path, e.message);
    return null;
  }
}
async function safeWrite(fn, label) {
  try { await fn(); } catch (e) { console.error(`[db] ${label} failed:`, e.message); }
}

// ---- Customers ----
export const loadCustomers = () => safeLoad("/customers");
export const saveCustomer = (record) => record && safeWrite(() => apiPost("/customers", record), "saveCustomer");
export const deleteCustomer = (id) => safeWrite(() => apiDel(`/customers/${id}`), "deleteCustomer");
export const seedCustomers = (records) => safeWrite(() => apiPost("/customers/seed", { records }), "seedCustomers");

// ---- Plans ----
export const loadPlans = () => safeLoad("/plans");
export const savePlan = (plan) => plan && safeWrite(() => apiPost("/plans", plan), "savePlan");
export const deletePlan = (id) => safeWrite(() => apiDel(`/plans/${id}`), "deletePlan");
export const seedPlans = (plans) => safeWrite(() => apiPost("/plans/seed", { records: plans }), "seedPlans");

// ---- Tasks ----
export const loadTasks = () => safeLoad("/tasks");
export const saveTask = (task) => task && safeWrite(() => apiPost("/tasks", task), "saveTask");
export const deleteTask = (id) => safeWrite(() => apiDel(`/tasks/${id}`), "deleteTask");
export const seedTasks = (tasks) => safeWrite(() => apiPost("/tasks/seed", { records: tasks }), "seedTasks");

// ---- Realtime (server SSE relay; ids only, refetch through the authed API) ----
export function subscribe(table, cb) {
  return onTable(table, () => { cb(); });
}
